export default {"src":"/_next/static/media/cross.501eba62.svg","height":22,"width":21};